import { render } from "./WorksPage.vue?vue&type=template&id=52b2c118&scoped=true"
import script from "./WorksPage.vue?vue&type=script&lang=js"
export * from "./WorksPage.vue?vue&type=script&lang=js"

import "./WorksPage.vue?vue&type=style&index=0&id=52b2c118&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52b2c118"]])

export default __exports__